import React from "react"
import { Controller } from "react-hook-form"
import { CustomPaymentConfig, InputCustomPaymentConfig } from "lib/types/generated/graphql-types"
import { SidebarDivider } from "../../DashboardSales/Shared.styled"
import Input from "components/Ui/Form/Input"
import { Control } from "react-hook-form/dist/types/form"
import { FieldErrors } from "react-hook-form/dist/types/errors"
import { WithAuth } from "../../Auth"
import { PermissionGroups } from "../../../routes/constants"
import FallbackInput from "../../Ui/Form/FallbackInput"

interface ExtendedInputCustomPaymentConfig {
  id: string
  customPaymentConfig: InputCustomPaymentConfig
}

type Props = {
  control: Control<ExtendedInputCustomPaymentConfig>
  errors: FieldErrors
  showId?: boolean
  defaultValues?: CustomPaymentConfig
}

export const CustomPaymentConfigInputs = ({
  control,
  errors,
  showId = true,
  defaultValues
}: Props) => {
  return (
    <>
      {showId && (
        <>
          <Controller
            name="id"
            render={({ field }) => (
              <Input
                {...field}
                type="text"
                label="Identifier *"
                description="For internal use in Brink"
                placeholder="Aa - Zz, 0 - 9, -_."
                errors={errors}
              />
            )}
            control={control}
            defaultValue=""
            rules={{
              required: "This is a required field",
              pattern: {
                value: /^[A-Za-z0-9_.-]+$/,
                message: "Only characters Aa-Zz and 0-9 are allowed. No spaces"
              }
            }}
          />
          <SidebarDivider />
        </>
      )}
      <WithAuth
        requiredGroups={PermissionGroups.providers.write}
        fallback={<FallbackInput label={"Base URL"} value={defaultValues?.baseUrl} />}
      >
        <Controller
          name="customPaymentConfig.baseUrl"
          render={({ field }) => (
            <Input {...field} type="text" errors={errors} label="Base URL *" />
          )}
          control={control}
          rules={{
            required: "This is a required field"
          }}
          defaultValue={defaultValues?.baseUrl ?? ""}
        />
      </WithAuth>
      <WithAuth
        requiredGroups={PermissionGroups.providers.write}
        fallback={<FallbackInput label={"Auth URL"} value={defaultValues?.authUrl} />}
      >
        <Controller
          name="customPaymentConfig.authUrl"
          render={({ field }) => (
            <Input {...field} type="text" errors={errors} label="Auth URL *" />
          )}
          control={control}
          rules={{
            required: "This is a required field"
          }}
          defaultValue={defaultValues?.authUrl ?? ""}
        />
      </WithAuth>
      <WithAuth requiredGroups={PermissionGroups.providers.write}>
        <Controller
          name="customPaymentConfig.clientId"
          render={({ field }) => (
            <Input {...field} type="text" errors={errors} label="Client ID *" />
          )}
          control={control}
          rules={{
            required: "This is a required field"
          }}
          defaultValue=""
        />
      </WithAuth>
      <WithAuth requiredGroups={PermissionGroups.providers.write}>
        <Controller
          name="customPaymentConfig.clientSecret"
          render={({ field }) => (
            <Input {...field} type="text" errors={errors} label="Client Secret *" />
          )}
          control={control}
          rules={{
            required: "This is a required field"
          }}
          defaultValue=""
        />
      </WithAuth>
    </>
  )
}
